import { render, staticRenderFns } from "./SupplierListModal.vue?vue&type=template&id=e56f89c2"
import script from "./SupplierListModal.vue?vue&type=script&lang=js"
export * from "./SupplierListModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e56f89c2')) {
      api.createRecord('e56f89c2', component.options)
    } else {
      api.reload('e56f89c2', component.options)
    }
    module.hot.accept("./SupplierListModal.vue?vue&type=template&id=e56f89c2", function () {
      api.rerender('e56f89c2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/supplier-prices/SupplierListModal.vue"
export default component.exports